import { createBaseApiClient } from './base-api-client';
import { clearCart } from './helpers';
import { ApiContracts } from './types';

interface ItsApiClientOptions {
  storeHash: string;
  isStaging?: boolean;
  defaultCacheTtl?: number;
}

export type ItsApiClient = ReturnType<typeof createItsApiClient>;

export function createItsApiClient({
  storeHash,
  isStaging = true,
}: ItsApiClientOptions) {
  const store_hash = storeHash.replace(/\s+/g, '');
  if (!store_hash || store_hash.length === 0)
    throw new Error('StoreHash is required to run [createItsApiClient]');

  const baseUrl = isStaging
    ? 'https://bbwheels.intuitsolutions-apps.net:20443/app/api'
    : 'https://bbwheels.intuitsolutions-apps.net/app/api';

  const baseApi = createBaseApiClient({
    store_hash,
    baseUrl,
  });

  function getServices() {
    return baseApi.request(`/services`, {
      method: 'GET',
      useCache: false,
    });
  }

  function getServiceOfferingsByVariantId(
    payload: ApiContracts['/services/offerings/product']['GET']['payload'],
  ) {
    return baseApi.request(`/services/offerings/product`, {
      method: 'GET',
      data: payload,
      useCache: false,
    });
  }

  function addServiceOfferingsToCart(
    payload: ApiContracts['/services/offerings/product']['POST']['payload'],
  ) {
    return baseApi.request(`/services/offerings/product`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      data: payload,
    });
  }

  function getServiceOfferingsByCartId(
    payload: ApiContracts['/services/offerings/cart']['GET']['payload'],
  ) {
    return baseApi.request('/services/offerings/cart', {
      method: 'GET',
      data: payload,
      pathParams: { cart_id: payload.cart_id },
      useCache: false,
    });
  }

  function syncCartById(
    payload: ApiContracts['/services/cart/{cart_id}/sync']['POST']['payload'],
  ) {
    return baseApi.request('/services/cart/{cart_id}/sync', {
      method: 'POST',
      data: payload,
      pathParams: { cart_id: payload.cart_id },
      useCache: false,
    });
  }

  return {
    cleanAllCache: baseApi.cleanAllCache,
    cleanExpiredCache: baseApi.cleanExpiredCache,
    clearCart,
    getServices,
    getServiceOfferingsByVariantId,
    addServiceOfferingsToCart,
    getServiceOfferingsByCartId,
    syncCartById,
  };
}
